import { render, staticRenderFns } from "./PartnershipG.vue?vue&type=template&id=2c4d402c&scoped=true"
import script from "./PartnershipG.vue?vue&type=script&lang=js"
export * from "./PartnershipG.vue?vue&type=script&lang=js"
import style0 from "./PartnershipG.vue?vue&type=style&index=0&id=2c4d402c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4d402c",
  null
  
)

export default component.exports